const translations = {
  "en": {
    "Accounts in. Ed's reading.": "Accounts in. Ed's reading.",
    "Ask Ed": "Ask Ed",
    "Connect an invest account": "Connect an invest account",
    "Connected, but I need an invest account": "Connected, but I need an invest account",
    "Daily market summary": "Daily market summary",
    "Ed couldn't generate your personal market report. Please try again later.": "Ed couldn't generate your personal market report. Please try again later.",
    "Ed is generating your daily market report...": "Ed is generating your daily market report...",
    "From tomorrow, this brief is built around what you actually own — your accounts, your moves, what they mean.": "From tomorrow, this brief is built around what you actually own — your accounts, your moves, what they mean.",
    "Got it": "Got it",
    "Link a brokerage, 401(k) or crypto wallet and tomorrow's summary starts from yours.": "Link a brokerage, 401(k) or crypto wallet and tomorrow's summary starts from yours.",
    "Loading daily market summary...": "Loading daily market summary...",
    "Not now": "Not now",
    "Today": "Today",
    "Today's summary isn't ready yet.": "Today's summary isn't ready yet.",
    "Your daily market report": "Your daily market report"
  },
  "zh-tw": {
    "Accounts in. Ed's reading.": "帳戶已匯入。Ed 正在分析。",
    "Ask Ed": "問問 Ed",
    "Connect an invest account": "連結投資帳戶",
    "Connected, but I need an invest account": "已連線，但需要投資帳戶",
    "Daily market summary": "每日市場摘要",
    "Ed couldn't generate your personal market report. Please try again later.": "Ed 無法產生你的個人市場報告。請稍後再試。",
    "Ed is generating your daily market report...": "Ed 正在生成你的每日市場報告...",
    "From tomorrow, this brief is built around what you actually own — your accounts, your moves, what they mean.": "自明日起，本摘要將以你的實際持倉為核心——你的帳戶、操作動向及其意涵。",
    "Got it": "了解",
    "Link a brokerage, 401(k) or crypto wallet and tomorrow's summary starts from yours.": "連結券商、401(k) 或加密貨幣錢包，明日摘要將以你的持倉為基礎。",
    "Loading daily market summary...": "正在載入每日市場摘要...",
    "Not now": "稍後再說",
    "Today": "今天",
    "Today's summary isn't ready yet.": "今日摘要尚未完成。",
    "Your daily market report": "你的每日市場報告"
  }
};

export default translations;
